export const BACKEND_CHANGELOG_RELEASES = [
  {
    "version": "1.67.0",
    "date": "2026-10-17",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "aplicar regras dinâmicas das Bluebox"
        ]
      }
    ]
  },
  {
    "version": "1.66.0",
    "date": "2026-10-15",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**cognito:** login com falha de configuracao responde 503 com o codigo do erro"
        ]
      }
    ]
  },
  {
    "version": "1.65.0",
    "date": "2026-10-15",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**aws:** credenciais com fallback e log do erro real do login Cognito"
        ]
      }
    ]
  },
  {
    "version": "1.64.0",
    "date": "2026-09-28",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**athena:** limite de 60s por query com cancelamento"
        ]
      }
    ]
  },
  {
    "version": "1.63.0",
    "date": "2026-09-28",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**thing:** coordenadas do park no top-generation para o mapa do app"
        ]
      }
    ]
  },
  {
    "version": "1.62.0",
    "date": "2026-09-28",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**thing:** top-generation com modo fleet e statusTypeId"
        ]
      }
    ]
  },
  {
    "version": "1.61.0",
    "date": "2026-09-28",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**thing:** top-generation com bluebox opcional e thingTypeId"
        ]
      }
    ]
  },
  {
    "version": "1.60.0",
    "date": "2026-09-28",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**thing:** expoe applianceId no top-generation"
        ]
      }
    ]
  },
  {
    "version": "1.59.0",
    "date": "2026-09-24",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**cognito:** login mobile com SECRET_HASH, refresh e 401 amigavel"
        ]
      }
    ]
  },
  {
    "version": "1.58.0",
    "date": "2026-09-03",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**user:** endpoint admin para definir senha manualmente"
        ]
      }
    ]
  },
  {
    "version": "1.57.0",
    "date": "2026-08-19",
    "groups": [
      {
        "title": "Features",
        "items": [
          "add audit log park and user filters"
        ]
      }
    ]
  },
  {
    "version": "1.56.0",
    "date": "2026-08-19",
    "groups": [
      {
        "title": "Features",
        "items": [
          "add audit logs and user last access"
        ]
      }
    ]
  },
  {
    "version": "1.54.0",
    "date": "2026-08-17",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**appliance:** support bluebox machine type"
        ]
      }
    ]
  },
  {
    "version": "1.53.0",
    "date": "2026-08-06",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**thing:** adiciona total de energia acumulado no top-generation"
        ]
      }
    ]
  },
  {
    "version": "1.52.0",
    "date": "2026-08-05",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "normalize historic chart timestamps"
        ]
      }
    ]
  },
  {
    "version": "1.51.0",
    "date": "2026-08-05",
    "groups": [
      {
        "title": "Features",
        "items": [
          "add bluebox machine support"
        ]
      }
    ]
  },
  {
    "version": "1.49.0",
    "date": "2026-07-20",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "persistir data de alertas de range"
        ]
      }
    ]
  },
  {
    "version": "1.47.0",
    "date": "2026-07-17",
    "groups": [
      {
        "title": "Features",
        "items": [
          "scope cco error alerts by user machines"
        ]
      }
    ]
  },
  {
    "version": "1.46.0",
    "date": "2026-07-16",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**variable:** permitir busca por nome ou descrição"
        ]
      }
    ]
  },
  {
    "version": "1.43.0",
    "date": "2026-06-24",
    "groups": [
      {
        "title": "Performance",
        "items": [
          "**variable:** TTL do cache de historico 15->30min + doc de pre-agregacao"
        ]
      }
    ]
  },
  {
    "version": "1.42.0",
    "date": "2026-06-24",
    "groups": [
      {
        "title": "Performance",
        "items": [
          "**appliance:** query energy-daily via index-seek (first/last por dia)"
        ]
      }
    ]
  },
  {
    "version": "1.41.0",
    "date": "2026-06-23",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**appliance:** cache nas series diarias de energia e vazao"
        ]
      }
    ]
  },
  {
    "version": "1.40.0",
    "date": "2026-06-23",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**appliance:** corrige deslocamento de data na serie diaria de energia/vazao"
        ]
      }
    ]
  },
  {
    "version": "1.39.0",
    "date": "2026-06-22",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**appliance:** periodo anterior na disponibilidade (pra DeltaPill)"
        ]
      }
    ]
  },
  {
    "version": "1.38.0",
    "date": "2026-06-18",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**user:** indices nas FK pra acelerar exclusao de usuario"
        ]
      }
    ]
  },
  {
    "version": "1.37.0",
    "date": "2026-06-16",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**thing:** adiciona flowLps (Vazao) ao ranking top-generation"
        ]
      }
    ]
  },
  {
    "version": "1.36.0",
    "date": "2026-06-12",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**thing:** modo consumo (EBA) no ranking top-generation"
        ]
      }
    ]
  },
  {
    "version": "1.35.0",
    "date": "2026-06-12",
    "groups": [
      {
        "title": "Refactor",
        "items": [
          "**config:** valida envs no boot com falha rapida e clara"
        ]
      }
    ]
  },
  {
    "version": "1.33.0",
    "date": "2026-06-12",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**core:** logging estruturado em JSON",
          "**core:** correlationId por request via AsyncLocalStorage",
          "**core:** metricas de cache e Athena via GET /api/v1/version/metrics"
        ]
      },
      {
        "title": "Correções",
        "items": [
          "**core:** import do tap compativel com rxjs 6"
        ]
      }
    ]
  },
  {
    "version": "1.32.0",
    "date": "2026-06-12",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**variable:** cache de 15min no historico (corta custo Athena)"
        ]
      },
      {
        "title": "Refactor",
        "items": [
          "**park:** unifica caches de ParkService e ParkServiceForMap"
        ]
      },
      {
        "title": "Correções",
        "items": [
          "**park:** invalida cache de parks no evento de status"
        ]
      }
    ]
  },
  {
    "version": "1.30.0",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**thing:** adiciona deteccao de anomalias estatistica v1 (GET /thing/:id/anomalies)",
          "**assistant:** adiciona tool get_anomalies ao copiloto (6a ferramenta)"
        ]
      }
    ]
  },
  {
    "version": "1.29.0",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**assistant:** adiciona tool get_recent_events ao copiloto CCO"
        ]
      }
    ]
  },
  {
    "version": "1.28.0",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**report:** copiloto CCO — POST /report/assistant com tool use Anthropic"
        ]
      }
    ]
  },
  {
    "version": "1.27.0",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**report:** endpoint GET /report/shift-summary com briefing de turno via IA",
          "**report:** endpoint GET /report/llm-status para feature-flag do LLM"
        ]
      }
    ]
  },
  {
    "version": "1.24.0",
    "date": "2026-06-09",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**thing:** expoe model do equipamento no ranking top-generation"
        ]
      }
    ]
  },
  {
    "version": "1.23.0",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Refactor",
        "items": [
          "**top-generation:** remove debug temporario pos-diagnostico"
        ]
      }
    ]
  },
  {
    "version": "1.22.0",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**top-generation:** substituir AppSync/IotRepository por DynamoDB direto"
        ]
      }
    ]
  },
  {
    "version": "1.21.0",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**thing:** corrige erro 'could not determine data type of parameter $1' no top-generation e activity para usuarios highPrivilege"
        ]
      }
    ]
  },
  {
    "version": "1.20.0",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**thing:** adiciona logs de diagnostico em buildTopGeneration e IotRepository"
        ]
      },
      {
        "title": "Correções",
        "items": [
          "**thing:** expoe _diag temporario em top-generation para diagnostico no browser"
        ]
      }
    ]
  },
  {
    "version": "1.19.0",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**top-generation:** corrige ranking vazio trocando DynamoDB por AppSync como fonte da PotenciaAtivaMedia"
        ]
      }
    ]
  },
  {
    "version": "1.18.0",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**thing:** endpoint GET /thing/top-generation para painel Top Geracao"
        ]
      }
    ]
  },
  {
    "version": "1.17.0",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**analytics:** endpoints de disponibilidade, MTBF/MTTR e Pareto de alarmes",
          "**usina:** tarifa de energia por cliente/usina e potencia nominal por maquina"
        ]
      }
    ]
  },
  {
    "version": "1.16.0",
    "date": "2026-06-08",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**park:** endpoint GET /park/pending-commands para indicar parques com comando pendente"
        ]
      }
    ]
  },
  {
    "version": "1.15.0",
    "date": "2026-06-04",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**alert:** adiciona thingName no TopAlarmDTO para identificar a maquina do alarme"
        ]
      }
    ]
  },
  {
    "version": "1.14.0",
    "date": "2026-06-03",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**parks:** anexa lastSeen (ISO-8601 UTC) em cada thing do payload de parks"
        ]
      },
      {
        "title": "Correções",
        "items": [
          "**command:** corrige hasCommandExecuted + endpoint GET pending-command"
        ]
      }
    ]
  },
  {
    "version": "1.12.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**websockets:** scoping por tenant via rooms socket.io (Fase 3)"
        ]
      }
    ]
  },
  {
    "version": "1.11.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Performance",
        "items": [
          "**park:** TTL de 55s no cache do getParks + batch DynamoDB no loadRealtimeForThings"
        ]
      }
    ]
  },
  {
    "version": "1.10.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**thing:** endpoint GET /thing/activity para historico de transicoes de status server-side"
        ]
      }
    ]
  },
  {
    "version": "1.9.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**websockets:** autenticacao JWT warn-only nos 9 gateways (Fase 1)"
        ]
      }
    ]
  },
  {
    "version": "1.8.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**security:** fase 5 hardening multi-tenant — completude e prevencao"
        ]
      }
    ]
  },
  {
    "version": "1.7.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**security:** fase 4 hardening — gatea endpoints de mutacao por papel e ownership"
        ]
      },
      {
        "title": "Correções",
        "items": [
          "**variable:** relaxa gate do POST /variable/ranges para roles nao-visualizador"
        ]
      }
    ]
  },
  {
    "version": "1.6.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**userthing:** corrige provisionamento de vinculos usuario<->thing"
        ]
      }
    ]
  },
  {
    "version": "1.5.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**dynamodb:** corrige calculo de frescor de dataUpdate independente de TZ do servidor"
        ]
      }
    ]
  },
  {
    "version": "1.4.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "**auth:** corrige escopo de Admin Local no hardening multi-tenant"
        ]
      }
    ]
  },
  {
    "version": "1.3.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Features",
        "items": [
          "**auth:** hardening multi-tenant fase 1 — guarda endpoints de escrita via TenantContextService",
          "**auth:** hardening multi-tenant fase 2 — guarda endpoints de leitura",
          "**security:** fase 3 hardening multi-tenant — zone ownership e command permission gate"
        ]
      }
    ]
  },
  {
    "version": "1.2.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "adiciona executor de migrations ao deploy"
        ]
      }
    ]
  },
  {
    "version": "1.1.0",
    "date": "2026-06-02",
    "groups": [
      {
        "title": "Correções",
        "items": [
          "reduce dashboard database load",
          "Ajuste de Log",
          "**energy-daily:** corrige exclusao de hoje, LEFT JOIN pra dias sem dados e warning sem things",
          "**energy-daily:** remove double-shift de timezone no LEFT JOIN",
          "**flow-daily:** corrige tabela errada em findDailyFlowBySeries",
          "**variable:** incluir customer no join e corrigir filtro customerId",
          "**thing:** registrar VariableRangeThingRepository nos modulos que usam ThingService",
          "**park:** expoe topAlarm em /park/list (ParkService, nao so ParkServiceForMap)",
          "**park:** computa topAlarm em parks amarelos (atencao por range warning)",
          "**park:** loadRangesForThings com queryBuilder + WHERE IN (TypeORM 0.2.x)",
          "**park:** topAlarm lookup usa Variable.ihmname (nao name) pra casar com Dynamo",
          "**park:** isRangeWarning agora deriva de parkTopAlarm (live), nao da flag estatica",
          "**version:** default minFrontendVersion 0.0.0 (sem restricao)",
          "**summary:** excluir things inativas dos agregados do dashboard",
          "**search:** excluir zones e customers sem things ativas do searchZoneOrCustomer",
          "**appliance:** filtrar things inativas em findThingsByAppliance e findThingById",
          "**variable:** corrige nomes de coluna nas subqueries de findByFilters (500 no /variable/filtered)",
          "**park:** status por-thing usa snapshot Dynamo ao vivo em vez da coluna Postgres defasada"
        ]
      },
      {
        "title": "Features",
        "items": [
          "**appliance:** adiciona previousTotalEnergyGenerated na response",
          "**variable:** aceita param 'date' opcional nos endpoints de historico",
          "**thing:** adiciona endpoints /type/trip e /type/block e torna efficiency resiliente",
          "**appliance:** adiciona endpoint GET :id/energy-daily para serie diaria de energia",
          "**appliance:** endpoint GET :id/flow-daily para historico diario de vazao da EBA",
          "**variable,thing:** adiciona GET /variable/types e GET /thing/list-light",
          "**thing:** endpoint bulk link variaveis PUT /thing/:id/variables",
          "**park:** expoe topAlarm com causa principal por park em /parks/for-map",
          "**park:** fallback firmware (AlarmesWord/AdvertenciaWord) no topAlarm",
          "**park:** camada per-variable de firmware (Alm_H_/Adv_L_) no topAlarm",
          "**park:** fallback 'Alarme do dispositivo' qdo as 3 camadas falham + cleanup",
          "**park:** statusSince — epoch de quando o park entrou em alarme",
          "**version:** endpoint publico GET /api/version para versionamento FE<->BE",
          "**user:** persistencia generica de preferencias de UI por usuario",
          "**thing:** ativar/desativar maquina (soft-hide)",
          "**appliance:** inclui thing.lastupdate na resposta de /appliance/filters",
          "**thing:** enriquece log operacional com range de limites e flag hasRearm"
        ]
      },
      {
        "title": "Performance",
        "items": [
          "**appliance:** paraleliza queries do getApplianceFilters com Promise.all",
          "**variable:** two-query strategy em findByFilters",
          "**/machines:** elimina N+1 no Dynamo (gargalo principal da listagem)",
          "**variable:** elimina 3 gargalos no GET /variable/filtered"
        ]
      },
      {
        "title": "Refactor",
        "items": [
          "**status:** documenta bit map do StatusWord1 em arquivo dedicado",
          "**status:** remove getStatusFromDynamo (lazy writer orfao)",
          "**status:** para de ler thing.rangeAlert no pipeline de status",
          "**thing:** elimina uso de rangeAlert (flag legada nunca atualizada)",
          "**park:** ParkServiceForMap estende ParkService (elimina clone)",
          "**dynamodb:** hasAlarmOrError usa STATUS_WORD_BIT.ALARM (vs numero magico)"
        ]
      }
    ]
  }
];

export const BACKEND_CHANGELOG_META = {
  "name": "CCO-Back",
  "version": "1.67.0",
  "source": "../higra-cco"
};
